var React = require( 'react' );
var createReactClass = require('create-react-class');
var DropDownList = require('./dropDownList.jsx');

var StatePicker = createReactClass({
  getInitialState: function() {
    return {
        feetList: [
            {"id": 1, "value": "1", "title": "1 foot"},
            {"id": 2, "value": "2", "title": "2 feet"},
            {"id": 3, "value": "3", "title": "3 feet"},
            {"id": 4, "value": "4", "title": "4 feet"},
            {"id": 5, "value": "5", "title": "5 feet"},
            {"id": 6, "value": "6", "title": "6 feet"},
            {"id": 7, "value": "7", "title": "7 feet"},
            {"id": 8, "value": "8", "title": "8 feet"},
        ],
        inchesList: [
            {"id": 0, "value": "0", "title": "0 inches"},
            {"id": 1, "value": "1", "title": "1 inch"},
            {"id": 2, "value": "2", "title": "2 inches"},
            {"id": 3, "value": "3", "title": "3 inches"},
            {"id": 4, "value": "4", "title": "4 inches"},
            {"id": 5, "value": "5", "title": "5 inches"},
            {"id": 6, "value": "6", "title": "6 inches"},
            {"id": 7, "value": "7", "title": "7 inches"},
            {"id": 8, "value": "8", "title": "8 inches"},
            {"id": 9, "value": "9", "title": "9 inches"},
            {"id": 10, "value": "10", "title": "10 inches"},
            {"id": 11, "value": "11", "title": "11 inches"},
        ]
    };
  },

  handleChange: function(value, event) {
    const { target: { name } } = event;
    this.setState({ [name]: value}, () => {
        const { feet, inches } = this.state;

        if (feet && inches) {
            const combinedFeetInches = parseInt((feet * 12), 10) + parseInt(inches, 10);
            var userResponse = {
                tag: 'height',
                text: `${combinedFeetInches} inches`,
                value: combinedFeetInches
            };
            this.props.response(userResponse);
        }
    });
  },

  render: function(){
    return (
        <div className="row">
            <div className="column small-5 small-offset-1 medium-3 medium-offset-3">
                <DropDownList
                    name="feet"
                    list={this.state.feetList}
                    value={this.props.value}
                    onChange={this.handleChange}
                    placeholder="Select feet..." />
            </div>
            <div className="column small-5 medium-3 end">
                <DropDownList
                    name="inches"
                    list={this.state.inchesList}
                    value={this.props.value}
                    onChange={this.handleChange}
                    placeholder="Select inches..." />
            </div>
        </div>
    );
  }
});

module.exports = StatePicker;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/pickers/heightPicker.jsx